document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.image-carousel-gallery-section');
    if (sections.length <= 0) return;

    sections.forEach(section => {
        const galleryItems = section.querySelectorAll('.image-carousel-gallery-item img');
        if (galleryItems.length <= 0) return;

        const swiperContainer = document.createElement('div');
        swiperContainer.className = 'swiper-container';
        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper';

        const swiperCloseButton = document.createElement('div');
        swiperCloseButton.className = 'swiper-close-button';
        swiperCloseButton.innerHTML = '&times;';

        const swiperButtonNext = document.createElement('div');
        swiperButtonNext.className = 'swiper-button-next';
        const swiperButtonPrev = document.createElement('div');
        swiperButtonPrev.className = 'swiper-button-prev';

        const swiperPagination = document.createElement('div');
        swiperPagination.className = 'swiper-pagination';

        swiperContainer.appendChild(swiperWrapper);
        swiperContainer.appendChild(swiperCloseButton);
        swiperContainer.appendChild(swiperButtonNext);
        swiperContainer.appendChild(swiperButtonPrev);
        swiperContainer.appendChild(swiperPagination);
        document.body.appendChild(swiperContainer);

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false, // Default to false, will be enabled if enough slides
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
            },
            pagination: {
                el: swiperPagination,
                clickable: true,
            },
        });

        galleryItems.forEach(item => {
            item.addEventListener('click', () => {
                const images = item.getAttribute('data-carousel-images')
                    .split(',')
                    .map(image => image.trim())
                    .filter(image => image.length > 0);

                if (images.length === 0) {
                    return; // Do nothing if no additional images exist
                }

                swiper.removeAllSlides();
                images.forEach(image => {
                    const slide = document.createElement('div');
                    slide.className = 'swiper-slide';
                    const img = document.createElement('img');
                    img.src = image;
                    slide.appendChild(img);
                    swiper.appendSlide(slide);
                });

                if (images.length > 1) {
                    swiper.params.loop = true;
                    swiper.loopCreate();
                } else {
                    swiper.params.loop = false;
                }

                swiperContainer.classList.add('active');
                swiper.update();
            });
        });

        swiperCloseButton.addEventListener('click', () => {
            swiperContainer.classList.remove('active');
        });
    });
});
